export const TOP_MENU_SCHEMA = [];

// 适配顶部工具栏裁剪按钮，无icon
export const TAILOR_PIC_NORMAL_WITHOUT_ICON = 'tailor-pic-normal-without-icon';
